import * as React from "react";
const SvgFiBrandsAdobe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M15.129 1.38h8.87v21.24zM8.878 1.38H0v21.24zM12.004 9.208l5.652 13.412h-3.705l-1.69-4.271H8.125z"
    />
  </svg>
);
export default SvgFiBrandsAdobe;
